module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAMCAYAAABbayygAAAAwUlEQVQYlX3Pv0rCYRSH8Y9vRmBXoIG7SzcQXkLXUJORCroUjS6Rs0v8poagQHTtGmpLiEKH7sHFJaKWI77Qny+c4TnnOXBOqSgKkS0McBp8HfwJZZt0cIgDbOMWK1xBysQztDHHSyx21sNc3MMi40X0foivaGbcxNsa8hsvMcJOPDbE+W/iPT7QQgkneMjFFvbRxSQqzxR3CRcY+zs3GKb47P0fcYZ6wiP6qGI3EyqooYenhGM0YnOJr6glnmN29A0pPSXhJHLXiQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ren.png
// module id = Pzng
// module chunks = 10